import { Card } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { notification } from "antd";
import Loader from "../../components/Loader";
import axiosInstance from "../../utils/api";

const Telemetry = () => {
  const [selected, setSelected] = useState("");
  const [loading, setLoading] = useState(false)
  const [values, setValues] = useState({
    tValues: [],
  });
  const [newValues, setNewValues] = useState({
    serial: [],
    telemetry: [],
  });

  //Get Data From Api
  useEffect(() => {
    setLoading(true)
    axiosInstance.get("https://api.cl-ds.com/admin/node/telemetry/")
      .then((fetchdata) => {
        setLoading(false)
        console.log(fetchdata.data);
        setValues({
          ...values,
          tValues: fetchdata.data,
        });
        console.log(values);
      }).catch(err=>{
        setLoading(false)
        console.log(err)
      })
  }, []);

  //selectedValue
  //Finds for serial in selected values, returns corresponding value in the same index telemetry
  const selectedValue = values.tValues.find(({ serial }) => serial === selected)?.telemetry;

  //onChange
  function onChangehandler(e) {
    setNewValues({
      ...newValues,
      [e.target.name]: e.target.value,
    });
  }

  //Final Submit
  const dataSubmit = () => {
    console.log(newValues);
    console.log("Submitted");
    alert(newValues);

    //Post
    const requestForPost = {
      method: "POST",
      headers: {
        Authorization: "Token 4ef76b7b1288bbda537123e0fd51a446bd0b0a2f",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newValues),
    };
    console.log(newValues);
    setLoading(true)
    axiosInstance("https://api.cl-ds.com/admin/node/telemetry/", newValues).then((response) => {
      setLoading(false)
      if (response.status === 200) {
        console.log(response.json());
      }
    }).catch(err=>{
        setLoading(false)
        console.log(err)
    })
  };

  const openResult = () => {
    notification.open({
      message: "Form Data",
      duration: 0,
      description: JSON.stringify(newValues, null, 2),
      onClick: () => {
        console.log("Button was clicked");
      },
    });
  };

  return (
    <>
    {loading && ( <Loader/> )}
      <span></span>
      <div className="col-lg-8 mx-auto">
        <div>
          <h2 className="text-center  pb-3"> Dashboard/Telemetry Value </h2>
        </div>

        <Card>
          <Card.Header style={{ backgroundColor: "#7952b3", color: "white" }}> Telemetry </Card.Header>
          <div className="p-2">
            <span></span>
            <Form onSubmit={dataSubmit} onChange={onChangehandler}>
              <Form.Group className="col-12 mb-3">
                <Form.Label id="serial"> Serial </Form.Label>
                <Form.Control as="select" name="serial" className="form-control" custom onChange={(e) => setSelected(e.target.value)}>
                  <option value="none" selected disabled hidden>
                    Select an Option
                  </option>
                  {values.tValues.map(({ serial }) => (
                    <option key={serial} value={serial} onChange={(e) => onChangehandler(e)}>
                      {serial}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group className="col-12 mb-3">
                <Form.Label id="telemetry"> Telemetry Version</Form.Label>
                <Form.Control
                  type="text"
                  name="telemetry"
                  onChange={(e) => onChangehandler(e)}
                  key={selectedValue}
                  defaultValue={selectedValue}
                  placeholder="Please enter a telemetry version"
                  initialValue="null"
                ></Form.Control>
              </Form.Group>

              <div style={{ textAlign: "center" }}>
                <Button variant="outline-primary" type="submit" onSubmit={dataSubmit}>
                  Submit
                </Button>

                <span></span>
              </div>
              <span></span>
            </Form>
          </div>
        </Card>

        <Button variant="outline-primary" style={{ float: "right" }} type="primary" onClick={openResult}>
          View Data
        </Button>
      </div>
    </>
  );
};

export default Telemetry;
